import { render, staticRenderFns } from "./ProgressoLavorazione.vue?vue&type=template&id=7408ec48&scoped=true"
import script from "./ProgressoLavorazione.vue?vue&type=script&lang=ts"
export * from "./ProgressoLavorazione.vue?vue&type=script&lang=ts"
import style0 from "./ProgressoLavorazione.vue?vue&type=style&index=0&id=7408ec48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7408ec48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7408ec48')) {
      api.createRecord('7408ec48', component.options)
    } else {
      api.reload('7408ec48', component.options)
    }
    module.hot.accept("./ProgressoLavorazione.vue?vue&type=template&id=7408ec48&scoped=true", function () {
      api.rerender('7408ec48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProgressoLavorazione.vue"
export default component.exports